import React from 'react';
import { Switch as UISwitch } from 'src/shared/components/ui/switch';
import { InputLabel } from 'src/shared/components/ui/input-label';
import { cn } from 'src/shared/helpers/utils';

type LabelPlacement = 'end' | 'start' | 'top' | 'bottom';

type SwitchProps = {
    checked: boolean;
    className?: string;
    label: string;
    labelPlacement?: LabelPlacement;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
};

const Switch = (props: SwitchProps) => {
    const { checked, className, onChange, label, labelPlacement = 'end', disabled } = props;

    const isLabelStart = labelPlacement === 'start';
    const isLabelEnd = labelPlacement === 'end';

    return (
        <div className={cn('inline-flex items-center gap-2', className)}>
            {isLabelStart ? <InputLabel className='order-1'>{label}</InputLabel> : null}
            <UISwitch checked={checked} onCheckedChange={onChange} disabled={disabled} role='switch' aria-label={label} />
            {isLabelEnd ? <InputLabel className='order-3'>{label}</InputLabel> : null}
        </div>
    );
};

export default Switch;
